module.exports = __webpack_public_path__ + "static/media/planning_process_vnt.c9430e08.png";